export default "__VITE_ASSET__d2d473f4__"